import React from 'react';
import { ShadcnReactTable } from '@talentmesh/table';
import { cn } from '@/lib/utils';
import { useShadcnTable } from '@/Hooks';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import createInviteCandidatesColumns from './useCreateInviteCandidatesColumns';
import CandidatesListHeader from './CandidateListHeader';
import SendInvitationsButton from './SendInvitationsButton';

const columns = createInviteCandidatesColumns();

const CandidatesList = (): React.JSX.Element => {
    const { candidates } = useInviteCandidateContext();

    const table = useShadcnTable({
        columns,
        data: candidates,
        autoResetPageIndex: false,
        getRowId: (row) => row.id,
        enableRowSelection: (row) => !row.original.isReadOnly,
        enableColumnDragging: false,
        enableColumnOrdering: false,
        enableColumnPinning: false,
        enableColumnResizing: false,
        enableStickyHeader: false,
        enableTableFooter: false,
        enableSorting: false,
        manualFiltering: false,
        manualSorting: false,
        manualPagination: false,
        rowCount: candidates.length,
        enableBottomToolbar: false,
        enableTopToolbar: true,
        enablePagination: false,
        layoutMode: 'grid',
        mantinePaginationProps: { showRowsPerPage: false },
        mantinePaperProps: { className: 'rounded-xl shadow-none' },
        mantineBottomToolbarProps: { className: 'shadow-none' },
        mantineTableHeadRowProps: (data) => {
            return {
                className: cn(
                    '[&_th]:p-2 [&_th:first-of-type]:pl-4 [&_th:last-of-type]:pr-4',
                    data.table.getRowCount() > 4 && '[&_th:last-of-type]:mr-3.75',
                ),
            };
        },
        mantineTableBodyProps: {
            className: 'h-full max-h-60 overflow-y-auto',
        },
        mantineTableBodyRowProps: (data) => {
            return {
                className: cn(
                    'h-15 [&_td]:p-2 [&_td:first-of-type]:pl-4 [&_td:last-of-type]:pr-4',
                    data.row.original.isReadOnly && '[&_td]:bg-muted/50',
                ),
            };
        },
        renderTopToolbar: (data) => <CandidatesListHeader table={data.table} />,
    });

    return (
        <div className="flex flex-col" data-cy="InvitedCandidateList">
            <ShadcnReactTable table={table} />
            <SendInvitationsButton table={table} />
        </div>
    );
};

export default CandidatesList;
